module.exports = __webpack_public_path__ + "img/up.f9908ea8.svg";